import dispatchEvent from '../utils/dispatch-event.js';
import EVENT from '../enums/event.js';

const endpoints = {
  add: '/cart/add.js',
  change: '/cart/change.js',
  get: '/cart.js',
};

const requestDefaults = {
  credentials: 'same-origin',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};

export const addToCart = (
  data,
  { element = document.body, eventOptions = {} } = {}
) => {
  return fetch(endpoints.add, {
    ...requestDefaults,
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(response => response.json())
    .then(response => {
      dispatchEvent(EVENT.CART.UPDATE, element, eventOptions);
      dispatchEvent(EVENT.CART.UPDATE, document, eventOptions);

      return response;
    });
};

export const changeQuantity = (
  data,
  { element = document.body, eventOptions = {} } = {}
) => {
  return fetch(endpoints.change, {
    ...requestDefaults,
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(response => response.json())
    .then(response => {
      dispatchEvent(EVENT.CART.UPDATE, element, eventOptions);
      dispatchEvent(EVENT.CART.UPDATE, document, eventOptions);

      return response;
    });
};

/** @param {number} line */
export const removeFromCart = (
  line,
  { element = document.body, eventOptions = {} } = {}
) => changeQuantity({ line, quantity: 0 }, { element, eventOptions });

export const getCart = () => {
  return fetch(endpoints.get, {
    method: 'GET',
  }).then(response => response.json());
};
